import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Typography, Form, Checkbox } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { AddUserModal } from "components";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import "./style.scss";

export const ManageNewsletter: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	// const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [usersWithAccess, setUsersWithAccess] = useState<any[]>([]);
	const [userStatus, setUserStatus] = useState<boolean>(false);
	const [userRoles, setUserRoles] = useState<CheckboxValueType[]>([]);
	// const [userData, setUserData] = useState<DataType[]>([]);
	const [birthdate, setBirthDate] = useState<string>("");
	const [users, setUsers] = useState<any[]>();
	// const [currentUserInfo, setCurrentUserInfo] = useState<any[]>([]);
	// const [usersInfoToEdit, setUsersInfoToEdit] = useState<any[]>([]);
	const [form] = Form.useForm();
	// const [editForm] = Form.useForm();

	// const handleDelete = (item: DataType) =>
	// 	setUserData((prevState) => prevState.filter((data) => data !== item));

	const menu = (
		<Menu
			selectable
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	// useEffect(() => {
	// 	setUserData([
	// 		{
	// 			key: "1",
	// 			name: "John Brown",
	// 			email: "john.brown@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 		{
	// 			key: "2",
	// 			name: "Jim Green",
	// 			email: "jim.green@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 		{
	// 			key: "3",
	// 			name: "Joe Black",
	// 			email: "joe.black@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 	]);
	// }, []);

	const columns: ColumnsType<any> = [
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
		{
			title: "IP",
			dataIndex: "ip",
			key: "ip",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{text ? text : "-"}</p>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso ao newsletter",
			key: "start_access",
			render: (_, record) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Checkbox
						checked={usersWithAccess.includes(_.email)}
						onChange={(e) => {
							if (e.target.checked) {
								setUsersWithAccess((prevState) => {
									if (prevState.includes(_.email)) {
										return prevState;
									}
									return [...prevState, _.email];
								});
								return;
							}
							setUsersWithAccess((prevState) =>
								prevState.filter((itens) => itens !== _.email)
							);
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "10%",
				};
			},
		},
		// {
		// 	title: "Grupo",
		// 	dataIndex: "group",
		// 	key: "group",
		// 	render: (t_, record) => (
		// 		<p style={{ margin: 0 }}>
		// 			{record?.roles?.map((item: any) => item?.name).join(", ")}
		// 		</p>
		// 	),
		// },

		// {
		// 	title: "",
		// 	key: "",
		// 	render: (_, record) => (
		// 		<Space size="middle">
		// 			<FormOutlined
		// 				className="edit"
		// 				onClick={() => {
		// 					setIsOpenEdit(true);
		// 					setCurrentUserInfo(
		// 						usersInfoToEdit.find((item) => item?.id === record?.id)
		// 					);
		// 				}}
		// 			/>
		// 		</Space>
		// 	),
		// },
	];

	useEffect(() => {
		setUsers(undefined);
		api
			.get(
				`/newsletters?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setUsers(res?.data?.data?.newsletters);
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});
		// eslint-disable-next-line
	}, [selectedValue, paginationInfo]);

	// useEffect(() => {
	// 	const getUpdatedInfo = async () => {
	// 		if (users) {
	// 			const infoToUpdate = await Promise.all(
	// 				users.map(async (item) => {
	// 					const {
	// 						data: {
	// 							data: { user },
	// 						},
	// 					} = await api.get(`/manager/users/${item.id}`);
	// 					return user;
	// 				})
	// 			);
	// 			console.log({ infoToUpdate });
	// 			setUsersInfoToEdit(infoToUpdate);
	// 		}
	// 	};
	// 	getUpdatedInfo();
	// }, [users]);
	return (
		<div className="newsletter">
			<AddUserModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				setUsers={setUsers}
			/>
			{/* <EditUsersModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				setUsers={setUsers}
				currentUserInfo={currentUserInfo}
			/> */}

			<div className="newsletter__container">
				<h1 className="newsletter__container__title">Newsletter</h1>
				<div className="newsletter__container__input">
					<div className="newsletter__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						usuários
					</div>
					<Input placeholder="Pesquisar..." />
					{/* <button
						className="newsletter__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Usuário
					</button> */}
				</div>
				<Table
					loading={users === undefined}
					columns={columns}
					dataSource={users}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
